import * as types from './actionTypes';
import * as certificateApi from '../api/certificate.api';
import * as baseApi from '../api/base.api';

export function dropFileCompleted(files) {
    return {
        type: types.CERTIFICATE_DROPPED,
        payload: files
    };
}

export function clientSecretsInitialize(clientSecrets) {
    return {
        type: types.CLIENTSECRET_INIT,
        payload: clientSecrets
    }
}

export function selectedRiziv(selectedIndex) {
    return {
        type: types.SELECTRIZIV,
        payload: selectedIndex
    }
}

export function initCompleted(state) {
    return {
        type: types.CERTIFICATE_INIT,
        payload: state
    };
}

export const uploadCertificate = ( files, formData ) => {
    return dispatch => {

        let form = formData || new FormData();
        for (var index = 0; index < files.length; index++) {
            var element = files[index];
            form.append('file', element);
        }

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        dispatch(uploadStart());

        baseApi.postWithConfig(`api/certificates/Upload`, form, config)
          .then(response => {
                dispatch(uploadSuccess(response.data));
        }, (error) => {
            if(error.statusCode === 409){
                dispatch(uploadFailure(error.message));
            }
            dispatch(uploadFailure(error.message));
        });
    };
};

const uploadStart = () => ({
    type: types.CERTIFICATE_UPLOAD_START,
    payload: {
        value:true
    }
});

const uploadSuccess = data => ({
    type: types.CERTIFICATE_UPLOAD,
    payload: {
        data
    }
});


const uploadFailure = error => ({
    type: types.CERTIFICATE_UPLOAD_ERROR,
    payload: {
        error
    }
});